module.exports = __webpack_public_path__ + "static/media/calender.f505d910.svg";